import { render, staticRenderFns } from "./ProductImagePreviewDialog.vue?vue&type=template&id=16ea8758&scoped=true&"
import script from "./ProductImagePreviewDialog.vue?vue&type=script&lang=js&"
export * from "./ProductImagePreviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProductImagePreviewDialog.vue?vue&type=style&index=0&id=16ea8758&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ea8758",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardText,VChip,VDialog,VIcon,VImg})
